import getBaseDomainWithoutApp from "utils/getBaseDomainWithoutApp";

const STAGEPANDA_DOMAIN = "stagepanda.com";
const STAGE_CV_DOMAIN = "stage.cv";

/**
 * The domain public speaker pages are served from, which is not the domain the
 * admin app runs on: the app lives on app.stagepanda.com while public pages
 * live on stage.cv. Other environments keep their own base domain.
 *
 * Returns the bare hostname on localhost, where there is no public domain.
 */
export function getPublicProfileDomain() {
  const baseDomain = getBaseDomainWithoutApp();

  return baseDomain === STAGEPANDA_DOMAIN ? STAGE_CV_DOMAIN : baseDomain;
}

/**
 * Builds a URL on a user's public speaker page.
 *
 * The public page lives on the user's own subdomain (e.g. https://nana24.stage.cv),
 * which is a different host from the admin app. On localhost there are no
 * subdomains, so the user travels as a `?username=` query param instead.
 *
 * @param path a path on the public page, e.g. "/book" or `/book/${bookingId}`.
 *             Defaults to the profile root.
 */
export default function getPublicProfileUrl(username: string, path = "") {
  const { hostname, port, protocol } = window.location;

  const normalizedPath =
    !path || path === "/" ? "" : path.startsWith("/") ? path : `/${path}`;

  if (hostname.includes("localhost") || hostname === "127.0.0.1") {
    const portSuffix = port ? `:${port}` : "";
    return `${protocol}//${hostname}${portSuffix}${
      normalizedPath || "/"
    }?username=${encodeURIComponent(username)}`;
  }

  return `https://${username}.${getPublicProfileDomain()}${normalizedPath}`;
}
